const phase4Fields = {}

export default phase4Fields;



/** WEBPACK FOOTER **
 ** ./src/forms/campaign/createPhase4.js
 **/